<template>
  <div
    class="rounded-t bg-white mb-0 px-6 py-6 flex justify-between uppercase font-bold items-center"
  >
    <button @click="handleGoBack" class="flex">
      <IconChevronLeft />
      <h3>{{ categoryName }}</h3>
    </button>
    <div class="text-center flex justify-end items-center">
      <button
        class="mr-4 inline-flex items-center bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
        type="button"
        @click="handleCreate"
      >
        Save
        <IconSync
          class="ml-1 animate-spin"
          v-if="categoryLoading['createLoading']"
        />
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import IconSync from "@/assets/icons/IconSync";
import IconChevronLeft from "@/assets/icons/IconChevronLeft";

export default {
  name: "CategoryCreatePageHeader",
  components: {
    IconSync,
    IconChevronLeft
  },
  computed: {
    ...mapGetters(["categoryLoading"])
  },
  props: {
    handleCreate: {
      type: Function,
      required: true
    },
    categoryName: {
      type: String,
      required: true
    }
  },
  methods: {
    handleGoBack() {
      this.$router.back();
    }
  }
};
</script>
